import { createAPI } from '../../common'

export default {
  // 获取根文件夹
  getFolderDocLibs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst0cz0epdMjct', 'get', config, vconfig),
  getFolderChildren: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst0dijmesfo', 'get', config, vconfig),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  // 获取稿签
  getAssetInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0jogp', 'get', config, {
      neverLoading: true
    }),
  // 获取详情
  getAssetDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0efubjm', 'get', config, {
      neverLoading: true
    }),
  // 注册
  postRegister: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0sfhjtufs', 'post', config, {
      neverLoading: true
    }),
  // 图片上传获取各种开关
  getPicModifyParam: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0qjdNpejgzQbsbn', 'get', config, {
      neverLoading: true
    }),
  postArticleGetTextAbstract: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0ufyuBctusbdu', 'post', config, vconfig), // 自动提取文本摘要
  getImageTags: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuFyuJnbhfUbht', 'get', config, {
      isHideErrorMessage: true
    }), // 获取图片自动化标签
  getShootTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tippuUjnf', 'get', config, {
      isHideErrorMessage: true
    }), // 获取图片拍摄时间
  postRetry: (config) => createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0sfusz', 'POST', config), // 重新抽图、重试
  postIntellCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0joufmmDifdl', 'POST', config), // 智能审核
  postIntellIdentify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0joufmmJefoujgz', 'POST', config), // 智能识别
  getSensitiveTips: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfotjujwfUjqt', 'GET', config), // 敏感提示
  postDetele: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0efmfuf', 'POST', config), // 敏感提示
  postArticleRevert: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0sftupsf', 'POST', config), // 回收站资源还原
  postArticleDeleteReal: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0efmfuf0dpnqmfufmz', 'POST', config), // 回收站资源彻底删除
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hbsbcbhf0qfsnjttjpo', 'GET', config), // 回收站是否有权限
  getDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0epxompbe', 'get', config), // 图片打包下载
  getDownloadUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0epxompbeVsm', 'get', config), // 图片下载
  getAssetImageDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qjd0efubjm', 'get', config), // 兼容图片库的图片详情接口
  checkResult: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0difdlSftvmu', 'GET', config), // 获取智能审核结果
  getActionLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0mpht', 'GET', config), // 获取流程记录
  // 资产稿库-稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0efubjm', 'get', config),
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0efubjm', 'get', config),
  // 资产稿库-写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0dsfbujpo0joju', 'get', config),
  // 资产稿库-写稿保存
  postSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0dsfbuf', 'post', config),
  // 资产稿库-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0efubjmbdujpot', 'get', config),
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0usbotgfs', 'POST', config), // 送审
  getExtract: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qjd0fyusbdu', 'post', config, {
      timeout: 60000
    }), // 抽图
  getE5ImageFile: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf', 'get', config, {
      neverLoading: true,
      ...vconfig
    }),
  getArticleCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0hfuBsujdmfDbut', 'get', config), // 获取分类树
  getSearchInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfbsdiJogp', 'get', config), // 获取检索用稿签
  getPhotoUserlist: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0vtfsMjtu', 'get', config, vconfig), // 获取上传人接口
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  checkStorageQuota: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0difdlTupsbhfRvpub', 'get', config, vconfig), // 校验存储配额判断是否允许上传
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 校验是否已经归档或选用
  checkSelection: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0difdlTfmfdujpo', 'POST', config),
  // 归档或选用
  selectionAsset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfmfdujpo', 'POST', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  // 获取图集封面数据索引数据
  getIndexDocID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuJoefyEpdJE', 'get', config),
  // 清晰度增强
  postGetClarityEnhance: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0dmbsjuzFoibodf', 'post', config),
  // 其他ai能力
  postPicIntell: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0qjdJoufmm', 'post', config),
  // 清晰度增强保存
  postGetSaveImage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tbwfQjd', 'post', config),
  // AI作图
  getAiPicUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0bjQjdVsm', 'get', config),
  // AI视频
  getAiVideoUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0bjWjefpVsm', 'get', config),
  // 腾讯云剪辑 从后台获取code
  getAuthorize: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dvuujoh0bvuipsj{f', 'GET', config),
  // 媒资库对接腾讯云剪
  getPlatform: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0dvuujoh0hfuQmbugpsn', 'get', config),
  // 手动签发音视频图片
  postAssetPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0qvcmjti', 'POST', config),
  // 个性化渠道推送媒资
  postMedialPush: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0nfejbQvti0qvti', 'post', config, vconfig),
  // 获取个性化渠道的分组信息
  getMediaGroups: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0nfejbQvti0hspvq', 'get', config, vconfig),
  // 获取个性化渠道
  getMedialPushCompany: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0nfejbQvti0dpnqboz', 'get', config),
  // 生产库-签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0jttvfQbqfs', 'post', config, {
      timeout: 90000
    }),
  //生产库-签发到畅享全媒体稿源稿库接口
  signRemoteRootForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0jttvfOfxtfejuSppu', 'post', config, {
      timeout: 90000
    }),
  // 生产库-签发到畅享全媒体部门库接口
  signRemoteEditForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0jttvfOfxtfejuFeju', 'post', config, {
      timeout: 90000
    }),
  // 音视频下载埋点
  saveEventStateDownload: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0epxompbe0sfdpse', 'post', config, vconfig),
  getUploadFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0hfuVqmpbeGpmefs', 'GET', config),
  // 通过原视频库获取数据迁移到生产库的id
  getVideoAssetID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0hfuBttfuJE', 'GET', config),

  /**
   * 获取图片
   * @param config
   * @returns {*|Promise<axios.AxiosResponse<any>>}
   */
  getImageUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0hfuJnbhfVsm', 'GET', config),
  // 加入组
  postJoinGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0kpjoHspvq', 'post', config),
  // 拆组
  postSplitGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tqmjuHspvq', 'post', config),
  // 成组
  postPicGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0qjdHspvq', 'post', config),
  /**
   * 资产库视频ai工具箱
   * @param ids
   * @param channel //1=视频去抖,2=视频色彩增强,3=视频清晰度提升,4=视频横转竖,5=视频去水印,6=视频老片修复
   */
  postVideoAiTolls: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0wjefpBjUpmmt', 'post', config),
  /**
   * 资产库视频ai工具箱--视频转GIF能力
   * @param id
   * @param inPoint //入点、格式 s.mmm
   * @param outPoint //出点、格式 s.mmm
   */
  postVideoToGif: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0upHjg', 'post', config),
  /**
   * 获取我的素材的存储信息
   */
  postPersonAssetStorage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpoBttfu0hfuTupsbhf', 'post', config),
  /**
   * 选用
   */
  postAssetSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0tfmfdu', 'post', config),
  /**
   * 重复选用提醒
   */
  postSelectRecords: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0fwfou0tfmfduSfdpset', 'post', config),
  /**
   * 获取稿签接口
   */
  postAdminLabel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60mjtuebub', 'post', config),
  /**
   * AI智能成片--获取音色列表
   */
  getAiVoiceList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0bjWpjdf', 'GET', config),
  /**
   * AI智能成片--新建一键成片任务
   */
  postAiProduce: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0wjefp0bjQspevdf', 'post', config),
  // 新建/修改智能签发任务
  postMamVideopubTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qvcmjti0qvcUbtl', 'POST', config),
  // 删除智能签发任务
  delMamVideopubTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qvcmjti0efmQvcUbtl', 'GET', config),
  // 获取任务下要签发的音视频列表
  getMamVideopubTaskList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qvcmjti0hfuMjtu', 'GET', config)
}
